export const THEME_PURCHASE_URL = "https://1.envato.market/RDGA9";
export const THEME_DOCUMENTATION_URL = "https://phox.whmcsdes.com/docs";
export const THEME_DEMOS_URL = "https://phox.whmcsdes.com/demos";
